(() => {
  const rules = [
    { tag: 'clearance', text: 'CLEARANCE', key: 'clearance' },
    { tag: 'Extra10', text: 'EXTRA 10%', key: 'extra-10' },
    { tag: '2FOR1', text: '2 FOR 1', key: 'two-for-one' },

    // Support both tags during the transition
    { tag: 'sale', text: 'SALE', key: 'sale' },
    { tag: 'SummerSale26', text: 'SALE', key: 'sale' },

    { tag: 'BackInStock', text: 'BACK IN STOCK', key: 'back-in-stock' },
    { tag: 'NewIn', text: 'NEW', key: 'new' },
    { tag: 'Exclusive', text: 'EXCLUSIVE', key: 'exclusive' },
  ];

  const normaliseTags = (tags) => {
    if (!Array.isArray(tags)) return [];
    return tags.map((tag) => String(tag).trim().toLowerCase());
  };

  const resolve = (tags) => {
    const normalisedTags = normaliseTags(tags);
    return rules.find((rule) => normalisedTags.includes(rule.tag.toLowerCase())) || null;
  };

  window.CharacterBadgeEngine = Object.freeze({ rules, resolve });
})();